
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  IDefaultShippingOrderModel,
  ITypeModel,
  IUserModel,
} from "@/api/types";
import Pagination from "@/components/Pagination/index.vue";
import CreateSelect from "./components/CreateSelect.vue";
import { searchCustomer } from "@/api/customer";
import {
  getInquirySheet,
  getInquiryStatus,
  getSalesmanList,
  exportInquirySheetHistoryPrice,
  deleteInquirySheet,
  exportInquirySheetDetail,
  exportSourceFile,
  matchInquiry,
  exportAskingHistory, updateCurrency,
} from "@/api/inquiry";
import { InquirySheet } from "./types";
import { ShippingOrderModel } from "@/model/shipping-order";
import { COMPANY_OPTIONS } from "@/constant";
import { doDownload } from "@/utils/oss-download";
import moment from "moment";
import {UserModule} from "@/store/modules/user";
moment().format();

@Component({
  name: "askingForQuotationManagement",
  components: {
    Pagination,
    CreateSelect,
  },
})
export default class extends Vue {
  private defaultTimeArr = [];
  private showSelect = false;
  private tableKey = 0;
  private companyCodeOptions = COMPANY_OPTIONS;
  private containerTypeOptionsList: ITypeModel[] = [];
  public shippingOrder: IDefaultShippingOrderModel[] = [];
  private sellerList: IUserModel[] = [];
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as InquirySheet[],
  };

  private actionName = {
    create: "新增",
    createContainerType: "新增柜型",
    editContainerType: "编辑柜型",
    confirmPutShipping: "确认放舱",
  };
  public shippingOrderStatusList: [{ name: string; desc: string }] = [
    { name: null, desc: null },
  ];

  private DilogForDate = [];

  private internationalTradeTermsOptions = [
    { label: "FOB", value: "1" },
    { label: "CIF", value: "2" },
    { label: "C&F", value: "3" },
  ];

  private handleSuccess() {
    this.showSelect = false;
    this.getList();
  }

  private paymentOptions = [
    { label: "定金", value: "1" },
    { label: "赊账付款(OA)", value: "2" },
    { label: "信用证(L/C)", value: "3" },
    { label: "付款交单(DP)", value: "4" },
    { label: "发货前付款", value: "5" },
    { label: "见提单付款", value: "6" },
    { label: "其它", value: "7" },
  ];

  private ladingTypeOptions = [
    { label: "正本", value: "1" },
    { label: "SWB", value: "2" },
    { label: "电放", value: "3" },
    { label: "异地放单", value: "4" },
    { label: "铁路运单COPY", value: "6" },
    { label: "公路运单", value: "7" },
  ];

  private selectSinosureOptions = [
    { label: "是", value: true },
    { label: "否", value: false },
  ];

  private JobPositionType = {
    seller: "seller",
    purchaser: "purchaser",
    logisticsClerk: "logistics-clerk",
  };
  private cascadeProps = {
    multiple: true,
    emitPath: false,
    value: "id",
    label: "name",
  };
  private total = 0;
  private listLoading = true;
  private selectedRow: ShippingOrderModel = new ShippingOrderModel();

  //对话框的一个状态
  private dialogStatus = "";
  private dialogFormVisible = false;
  private containerTypeVisible = false;
  private confirmPutShippingVisible = false;

  private pickerOptions = {
    shortcuts: [
      {
        text: "最近半年",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近一年",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近两年",
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
          picker.$emit("pick", [start, end]);
        },
      },
    ],
  };

  configuredContainerTypes = [{ id: null, name: null, value: null }];
  public listParam = {
    inquirySheetCode: null,
    customerId: null,
    sellerId: null,
    inquiryStatus: null,
    startTime: null,
    endTime: null,
    time: null,
  };
  public searchForm = [
    {
      label: "询价单号",
      prop: "inquirySheetCode",
      key: "inquirySheetCode",
      type: "input",
      value: "",
      placeholder: "请输入询价单号",
    },
    {
      label: "客人简称或编号",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "全部",
      remote: true,
      remote_method: this.getCustomer,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" },
    },
    {
      label: "询价时间",
      prop: "time",
      key: "time",
      type: "datePicker",
      value: "",
    },
    {
      label: "销售员",
      prop: "sellerId",
      key: "sellerId",
      type: "select",
      options: [],
      value: "",
      placeholder: "全部",
    },
    {
      label: "询价状态",
      prop: "inquiryStatus",
      key: "inquiryStatus",
      type: "select",
      value: "",
      options: [],
      placeholder: "全部",
      resetKey: { label: "desc", value: "name" },
    },
  ];
  public tableCol = [
    {
      label: "交易公司",
      prop: "company",
      key: "company",
      show: true,
      fixed: true,
      disabled: false,
    },
    {
      label: "询报价单号",
      prop: "code",
      key: "code",
      show: true,
      fixed: true,
      disabled: false,
      type: "linkWithState",
      typeNoKey: 'inquiryStatus',
      typeNoValue: '未匹配',
      width: 150
    },
    {
      label: "客人编号/名片编号",
      prop: "customerCode",
      key: "customerCode",
      show: true,
      disabled: false,
      width: 150,
    },
    {
      label: "客人简称",
      prop: "customerAbbreviation",
      key: "customerAbbreviation",
      show: true,
      disabled: false,
      render: (prop, row)=>{
        if (row.pcName && row.pcName.length > 0){
          return `[${row.pcName}]${prop}`
        }
        return prop
      }
    },
    {
      label: "客人国家",
      prop: "nation",
      key: "nation",
      show: true,
      disabled: false,
    },
    {
      label: "询价型号数",
      prop: "modelCount",
      key: "modelCount",
      show: true,
      disabled: false,
    },
    {
      label: "销售员",
      prop: "seller",
      key: "seller",
      show: true,
      disabled: false,
    },
    {
      label: "币种",
      prop: "currency",
      key: "currency",
      show: true,
      disabled: false,
    },
    {
      label: "询价状态",
      prop: "inquiryStatus",
      key: "inquiryStatus",
      show: true,
      disabled: false,
      // type: "status",
      // typeList: [],
    },
    {
      label: "最新上传时间",
      prop: "lastUploadTime",
      key: "lastUploadTime",
      show: true,
      disabled: false,
      width: 150,
    },
    {
      label: "匹配结果",
      prop: "matchingResult",
      key: "matchingResult",
      show: true,
      disabled: false,
      width: 300,
    },
    {
      label: "维护状态",
      prop: "taskState",
      key: "taskState",
      show: true,
      disabled: false,
      width: 300,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "上传",
          code: "",
          click: "handleReUpload",
          key: "inquiryStatus",
          value: "未匹配,匹配完成,错误，未下单",
        },
        {
          name: "导出详情",
          code: "",
          click: "handleExportDetail",
          key: "inquiryStatus",
          value: "匹配完成,未下单,审核中,部分下单,全部下单",
        },
        {
          name: "单据流",
          code: "",
          click: "gotoDocumentFlow",
          key: "inquiryStatus",
          value: "部分下单,全部下单",
        },
        {
          name: "更多",
          type: "more",
          actions: [
            {
              name: "删除",
              code: "",
              click: "handleDelete",
              type: "delete",
              key: "inquiryStatus",
              value: "未匹配,匹配完成,未下单,错误",
            },
            {
              name: "修改币种",
              code: "",
              click: "editCurrency",
              key: "inquiryStatus",
              value: "未匹配,待上传报价,错误,匹配完成",
            },
            { name: "下载源文件", code: "", click: "handleDownloadFile" },
            {
              name: "导出询价单历史报价",
              code: "",
              click: "exportAskingHistory",
              key: "inquiryStatus",
              value: "匹配完成,未下单,审核中,部分下单,全部下单",
              account:['A','A_B']
            },
          ],
        },
      ],
      show: true,
      disabled: false,
      width: 280,
    },
  ] as any;

  private currentRow = {} as any;

  created() {
    if (this.$route.params.code) {
      this.listParam.inquirySheetCode = this.$route.params.code as any;
      this.searchForm[0].value = this.$route.params.code as any;
    } else if(this.$route.query.code) {
      this.listParam.inquirySheetCode = this.$route.query.code as any;
      this.searchForm[0].value = this.$route.query.code as any;
    }
    // if(this.$route.query.piCode) {
    //   this.searchForm[0].value = this.$route.query.piCode as any
    //   this.searchForm[0].placeholder = this.$route.query.piCode as any
    //   this.listParam.inquirySheetCode = this.$route.query.piCode as any
    //   this.init();
    // }else{
    //   this.init();
    // }
    this.init();
  }

  activated() {
    if (this.$route.params.code) {
      this.listParam.inquirySheetCode = this.$route.params.code as any;
      this.searchForm[0].value = this.$route.params.code as any;
    } else if(this.$route.query.code) {
      this.listParam.inquirySheetCode = this.$route.query.code as any;
      this.searchForm[0].value = this.$route.query.code as any;
    }
    this.init();
  }

  private init() {
    this.getList();
    this.getInquiryStatus();
    this.getSalesmanList();
    this.getCustomer();
  }

  private async getInquiryStatus() {
    const res: any = await getInquiryStatus();
    this.searchForm[4].options = res;
    // this.tableCol[7].typeList = res;
  }

  private async getSalesmanList() {
    const res: any = await getSalesmanList();
    this.searchForm[3].options = res;
  }

  private changeValue(val: any) {
    const { key, value } = val;
    this.listParam[key] = value;
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = false;
    const { total, list }: any = await getInquirySheet(params);
    list.forEach((item) => {
      item.matchingResult = this.getResult(item);
    });
    this.table.total = +total;
    this.table.list = list;
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }
  getResult(item) {
    item.quoted = item.quoted || item.quoted === 0 ? item.quoted : "-";
    item.pendingQuoted =
      item.pendingQuoted || item.pendingQuoted === 0 ? item.pendingQuoted : "-";
    item.noResult = item.noResult || item.noResult === 0 ? item.noResult : "-";
    return `报价：${item.quoted}  | 待报价：${item.pendingQuoted} | 无结果：${item.noResult} | 被锁定：-`;
  }

  // 询价单跳转单据流
  private gotoDocumentFlow(data) {
    this.$router.push({
      name: "DocumentFlow",
      params: { type: "INQUIRY_SHEET", documentId: data.row.id },
    });
  }

  private currentCurrency = "";
  private editCurrencyDialog = false;
  private currencyList = [
    {label: "USD", value: "USD"},
    {label: "EURO", value: "EURO"},
    {label: "RMB", value: "RMB"},
  ]
  // 修改币种
  private editCurrency(scope) {
    this.currentRow = scope.row;
    this.currentCurrency = scope.row.currency;
    this.editCurrencyDialog = true;
  }

  // 确认修改币种
  private async confirmEditCurrency() {
    await updateCurrency(this.currentRow.id, {currency: this.currentCurrency})
        .then(() => {
          this.editCurrencyDialog = false;
          this.getList();
        })
        .catch(() => this.editCurrencyDialog = false);
  }

  //  删除
  public async handleDelete(scope) {
    try {
      await deleteInquirySheet(scope.row.id);
      this.$notify({
        title: "成功",
        message: "删除成功",
        type: "success",
        duration: 2000,
      });
      this.getList();
    } catch (e) {
      this.getList();
    }
  }

  private showDilogForDate = false;

  // 需求更改了
  // private async exportAskingHistory(row) {
  //   const endT = new Date();
  //   const startT = new Date();
  //   startT.setTime(startT.getTime() - 3600 * 1000 * 24 * 365);
  //   this.DilogForDate = [
  //     moment(startT.getTime()).format("YYYY-MM-DD HH:mm:ss"),
  //     moment(endT.getTime()).format("YYYY-MM-DD HH:mm:ss"),
  //   ];
  //   console.log("defaultTimeArr", this.DilogForDate);
  //   this.changeDilogForDateID = row.row.id;
  //   this.showDilogForDate = true;
  // }

  // 导出详情
  public async handleExportDetail(scope) {
    const res = await exportInquirySheetDetail(scope.row.id, UserModule.accountType[0]);
    console.log("types",UserModule.accountType)
    doDownload(res as any);
  }

  private linkClick(scope) {
    // let item = JSON.stringify(scope.row);
    // if (item.indexOf("&") != -1) {
    //   item = item.replace("&", "replace");
    // }
   if (scope.row.inquiryStatus === '未匹配'){
     return;
   }
    this.$router.push(
      `/enquiryQuotationDetails?id=${scope.row.id}&item=${scope.row.code}&updateExtendsOptionsCode=${scope.row.updateExtendsOptionsCode}&inquiryStatus=${scope.row.inquiryStatus}`
    );
  }

  // 重新上传
  private async handleReUpload(scope) {
    const { customerAbbreviation, customerId, id } = scope.row;
    this.$router.push({
      path: `/formUploadTool?id=${id}&customerId=${customerId}&customerAbbreviation=${customerAbbreviation}&type=inquiryLibrary`,
    });
  }

  // 下载源文件
  public async handleDownloadFile(scope) {
    if (!scope.row.taskId) {
      return this.$message.error("请先上传询价单");
    }
    await exportSourceFile(scope.row.taskId);
    // console.log(res);
    // doDownload(res as any);
  }

  private exportAskingHistoryLoading = false;

  private async exportAskingHistory(row) {
    // 需求修改不需要时间了
    // if ((this.DilogForDate.length = 0)) {
    //   this.$notify({
    //     title: "提示",
    //     message: "请选择时间范围",
    //     type: "error",
    //     duration: 2000,
    //   });
    //   return;
    // }
    // this.exportAskingHistoryLoading = true;
    // let params = {
    //   startTime: this.DilogForDate[0],
    //   endTime: this.DilogForDate[1],
    // };
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    await exportAskingHistory(row.row.id)
      .then((res) => {
        // this.exportAskingHistoryLoading = false;
        // this.showDilogForDate = false;
        loading.close();
      })
      .catch((err) => {
        console.log(err);
        // this.exportAskingHistoryLoading = false;
        loading.close();
      });
  }

  // 匹配报价
  private async handleMatch(scope) {
    if (!scope.row.taskId) {
      this.$message.error("请先上传询价单");
      this.handleReUpload(scope);
      return;
    }
    try {
      await matchInquiry(scope.row.taskId);
      this.$notify({
        title: "成功",
        message: "提交成功",
        type: "success",
        duration: 2000,
      });
      this.getList();
    } catch (e) {
      this.getList();
    }
  }

  // 导出询价单历史价格
  public async handleExport() {
    const { customerId, time } = this.listParam;
    if (time && time.length) {
      this.listParam.startTime = time[0];
      this.listParam.endTime = time[1];
    }
    const params = {
      customerId,
      startTime: this.listParam.startTime,
      endTime: this.listParam.endTime,
    };
    const res = await exportInquirySheetHistoryPrice(params);
    doDownload(res as any);
  }

  public querySearch(data) {
    this.listParam = data && data !== "reset" ? data : {};
    if (data.time && data.time.length) {
      this.listParam.startTime = data.time[0];
      this.listParam.endTime = data.time[1];
    }
    delete data.time;
    this.getList();
  }

  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.searchForm[1].options = res;
  }

  private selectedRows: IDefaultShippingOrderModel[] = [];

  private onSelectionChange(rows: IDefaultShippingOrderModel[]) {
    this.selectedRows = rows;
  }
}
